import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const DefaultDashboardSettings: React.FC = () => {
  const { userProfile } = useAuth();
  
  // We now only have business dashboard, so this component is no longer needed
  return null;
};

export default DefaultDashboardSettings; 